import styled, { css } from 'styled-components';
import { tint } from 'polished'

interface ContainerProps {
  hideInput: boolean
  selectedIndex: number
}

interface CellProps {
  isFocused: boolean
  isFilled: boolean
}

export const Container = styled.div<ContainerProps>`
  margin: 40px 0;

  > div {
    display: flex;
    position: relative;

    input {
      background-color: transparent;
      position: absolute;
      border: none;
      outline: none;
      height: 32px;
      width: 40px;
      top: 0px;
      bottom: 0px;
      text-align: center;

      left: ${props => (props.selectedIndex * 40) + ((props.selectedIndex) * 16)}px;
      opacity: ${ props => props.hideInput ? 0 : 1};
    }
    input[type=number]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    }
    input[type=number] {
      -moz-appearance: textfield;
      appearance: textfield;
    }
  }
`

export const Cell = styled.div<CellProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  width: 40px;
  height: 32px;
  border-bottom: 2px solid #DEE3E1;

  font-size: 40px;
  font-weight: 600;
  color: ${props => props.theme.colors.mainColor};

  & + div {
    margin-left: 16px;
  }

  ${
    props =>
      props.isFilled &&
      css`
        border-color: ${props => tint(0.4, props.theme.colors.mainColor)};
      `}

  ${
    props =>
      props.isFocused &&
      css`
        border-color: ${props => props.theme.colors.mainColor};
      `}

`
